import { downloadFile, request, uploadFile } from "@/utils/request";
import { DATE_FORMAT } from "@/constants/common";
import moment from "moment";
import { FILES_ENDPOINTS } from "../services/files";

export const HelpersMixin = {
  dateFormat: DATE_FORMAT,
  methods: {
    $formatDate(date, dateFormat=DATE_FORMAT) {
      return date ? moment(date).format(dateFormat) : "";
    },
    $getNumericalValue(value, round = 2, zeroValue = "-") {
      if (value === "0.0 %" || value === "NaN%") {
        return "0 %";
      }
      if (!value || value === "NaN") return zeroValue;
      if (typeof value === typeof 1) {
        if (value === 0) {
          return zeroValue;
        }
        value = value.toFixed(round).replace(/\B(?=(\d{3})+(?!\d))/g, "\xa0");
      }
      if (value === "0") {
        return zeroValue;
      }
      return value;
    },
    $getSearchParam(key = null) {
      const { query } = this.$route;
      if (!key) return query;
      return query?.[key] || null;
    },
    $setSearchParam(param, value = null) {
      const newQuery = { ...this.$route.query };
      const isQueryObject = typeof param === typeof {};
      if (!param || (isQueryObject && !Object.keys(param).length)) {
        return;
      }
      if (isQueryObject) {
        Object.entries(param).forEach(([filter, values]) => {
          const newValue = typeof values === typeof {} ? values.value : values;
          if (!newValue) delete newQuery[filter];
          else newQuery[filter] = newValue;
        });
      } else {
        if (!value) delete newQuery[param];
        else newQuery[param] = value;
      }

      this.$router.replace({ query: newQuery }).catch((err) => err);
    },
    $request(parameters) {
      return request(parameters);
    },
    $uploadFile(parameters) {
      return uploadFile(parameters);
    },
    $downloadFile(parameters) {
      return downloadFile(parameters);
    },
    async $deleteResource({
      resourceName = null,
      deleteUrl = FILES_ENDPOINTS.delete,
      callbackFunction = () => {},
      query = {},
    }) {
      if (
        !(await confirm(
          `Are you sure you want to delete ${resourceName || "this resource"}?`
        ))
      )
        return false;
      const { res } = await request({
        url: deleteUrl,
        method: "DELETE",
        query: query,
      });
      if (res.status === 200) {
        alert(
          `${
            resourceName || "Selected resource"
          } has been deleted successfully`,
          { color: "success", store: this.$store }
        );
        callbackFunction();
        return true;
      } else {
        alert("Something went wrong", {
          color: "danger",
          store: this.$store,
        });
        return false;
      }
    },
    $capitalize(text) {
      return text.slice(0, 1).toUpperCase() + text.slice(1);
    },
    $selectObjectKeys(obj, ...args){
      return ({
        ...args.reduce((res, key) => ({ ...res, [key]: obj[key] }), { })
      })
    },
  },
};
